// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1kaaI","fill":"styles_fill__3Dk-c"};